export enum ActivityStatus {
  NEW = 'new',
  ACTIVATE = 'activate',
  INACTIVATE = 'inactivate',
}
